import { createContext } from "react"
import useGetIMriImageUploads from "../useGetIMriImageUploads";

export interface IMriImageUploadsContext extends ReturnType<typeof useGetIMriImageUploads> {
}

export const MriImageUploadsContext = createContext<IMriImageUploadsContext>({
    data: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default MriImageUploadsContext;